// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__31fzU","head":"Table_head__3can3","col":"Table_col__2xIhh"};